import CartChoosePaymentPageV2 from './CartChoosePaymentPageV2'

export default CartChoosePaymentPageV2
// eslint-disable-next-line import/export
export * from './CartChoosePaymentPageV2'
